import MessageIcon from '@mui/icons-material/Message'
import ReactDOM from 'react-dom'

import ExpoLogo from 'pared/images/Expo/expo-symbol-white-1x.svg'
import { getUser } from 'pared/utils/user'

import {
  ButtonGroup,
  ChatButton,
  ChatButtonContainer,
  ChatButtonTitle,
  ChatHeader,
  ChatIcon,
  ChatIframe,
  ChatWindow,
  HeaderTitle,
  StyledExpandIcon,
  StyledIconButton,
  StyledShrinkIcon,
} from './styles'
import { IPropsType } from './types'
import { useFeV2ChatBox } from './useFeV2ChatBox'

export type { IPropsType }

const FeV2ChatBox = ({
  agentType,
  enabled = true,
  description,
  bubblePrompts,
  width,
  height,
  hideFromNonExpoUsers = false,
  disableInputField = false,
  sendStoreId,
  useThinking,
  useLocalAgent,
}: IPropsType) => {
  const { isOpen, setIsOpen, isExpanded, setIsExpanded, iframeUrl, iframeRef } =
    useFeV2ChatBox({
      agentType,
      description,
      bubblePrompts,
      disableInputField,
      sendStoreId,
      useThinking,
      useLocalAgent,
    })

  const user = getUser()
  if (hideFromNonExpoUsers && !user?.email?.endsWith('@getexpo.com')) {
    return null
  }

  if (!enabled) return null

  const chatContent = (
    <>
      <ChatButtonContainer isOpen={isOpen}>
        <ChatButton onClick={() => setIsOpen(!isOpen)}>
          <MessageIcon />
          <ChatButtonTitle>Ask Sous</ChatButtonTitle>
        </ChatButton>
      </ChatButtonContainer>

      <ChatWindow
        isOpen={isOpen}
        width={width}
        height={height}
        isExpanded={isExpanded}
      >
        <ChatHeader
          isOpen={isOpen}
          isExpanded={isExpanded}
          onClick={() => setIsOpen(false)}
        >
          <HeaderTitle>
            <ChatIcon src={ExpoLogo} alt="Expo Logo Icon" />
            Ask Sous
          </HeaderTitle>
          <ButtonGroup>
            {isExpanded ? (
              <StyledShrinkIcon
                onClick={(e) => {
                  e.stopPropagation()
                  setIsExpanded(false)
                }}
              />
            ) : (
              <StyledExpandIcon
                onClick={(e) => {
                  e.stopPropagation()
                  setIsExpanded(true)
                }}
              />
            )}
            <StyledIconButton
              onClick={(e) => {
                e.stopPropagation()
                setIsOpen(false)
                setIsExpanded(false)
              }}
            />
          </ButtonGroup>
        </ChatHeader>
        <ChatIframe
          ref={iframeRef}
          src={iframeUrl}
          title="FE2 Sous Chat"
          allow="microphone"
        />
      </ChatWindow>
    </>
  )

  return ReactDOM.createPortal(chatContent, document.body)
}

export default FeV2ChatBox
